import React, { useEffect, useState } from "react";

import Header from "../master/SideBar";
import Nav from "../master/NavBar";

import { ScheduleList, TimetableList } from "../../api/TimeTableService";
import { formatTime, SweetAlertShow } from "../master/Master";
import { getBatchNCourseList } from "../../api/BatchService";
import { StaffList } from "../../api/Staff";

import Master from "./Master";
import { printElementV2 } from "../master/Print";
import usePrivateLink from "../config/usePrivateLink";

export default function TimetableDayWise() {
    const hasAccess = usePrivateLink();

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [batches, setBatches] = useState([]);
    const [staffs, setStaffs] = useState([]);
    const [schedules, setSchedules] = useState([]);
    const [filterBatch, setFilterBatch] = useState("");
    const [filterTeacher, setFilterTeacher] = useState("");

    const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

    const parseDays = (value) => {
        if (Array.isArray(value)) return value;
        try {
            return JSON.parse(value || "[]");
        } catch {
            return [];
        }
    };

    const getScheduleList = async () => {
        try {
            const res = await ScheduleList();
            if (res?.data?.status) {
                setSchedules(res?.data?.data || []);
            } else {
                setSchedules([]);
            }
        } catch (error) {
            setSchedules([]);
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message || error?.message || "Unable to load schedules."
            );
        }
    };

    const getBatchList = async () => {
        try {
            const res = await getBatchNCourseList();
            if (res?.data?.status) {
                setBatches(res?.data?.data || []);
            } else {
                setBatches([]);
            }
        } catch (error) {
            setBatches([]);
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message || error?.message || "Unable to load batches."
            );
        }
    };

    const getStaffList = async () => {
        try {
            const res = await StaffList();
            if (res?.data?.status && Array.isArray(res?.data?.data)) {
                setStaffs(res.data.data);
            } else {
                setStaffs([]);
            }
        } catch {
            setStaffs([]);
        }
    };

    const getTimetableList = async () => {
        try {
            setLoading(true);

            let addUrl = "";
            if (filterBatch) addUrl += `&batch_id=${filterBatch}`;
            if (filterTeacher) addUrl += `&teacher_id=${filterTeacher}`;

            const res = await TimetableList(addUrl);
            if (res?.data?.status) {
                setData(res?.data?.data || []);
            } else {
                setData([]);
            }
        } catch (error) {
            setData([]);
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message || error?.message || "Unable to load timetable."
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getScheduleList();
        getBatchList();
        getStaffList();
    }, []);

    useEffect(() => {
        if (!filterBatch && !filterTeacher) {
            setData([]);
            return;
        }
        getTimetableList();
    }, [filterBatch, filterTeacher]);

    const findGroup = (scheduleId, day) => {
        return (data || []).filter((item) => {
            const sameSchedule = String(item.schedule_id) === String(scheduleId);
            const itemDays = parseDays(item.day);
            const sameDay = itemDays.includes(day);
            return sameSchedule && sameDay;
        });
    };

    const resetFilters = () => {
        setFilterBatch("");
        setFilterTeacher("");
    };

    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Header />

                <div className="layout-page">
                    <Nav />

                    <div className="content-wrapper">
                        <div className="container-fluid mt-3">
                            <div className="row">
                                <Master />

                                <div className="col-md-12">
                                    <div className="card mb-3 border-0 shadow-sm">
                                        <div className="card-body">
                                            <h5 className="text-primary fw-bold mb-1">
                                                <i className="bi bi-calendar3 me-2"></i>
                                                Day Wise Time Table
                                            </h5>

                                            <p className="text-muted mb-4" style={{ fontSize: "14px" }}>
                                                View complete timetable day wise and schedule wise
                                            </p>

                                            <div className="row g-3 align-items-end">
                                                <div className="col-md-4 col-sm-6">
                                                    <label className="form-label fw-semibold">Batch</label>
                                                    <select
                                                        className="form-select"
                                                        value={filterBatch}
                                                        onChange={(e) => setFilterBatch(e.target.value)}
                                                    >
                                                        <option value="">Select Batch</option>
                                                        {batches.map((batch) => (
                                                            <option key={batch.id} value={batch.id}>
                                                                {batch.title}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="col-md-4 col-sm-6">
                                                    <label className="form-label fw-semibold">Teacher</label>
                                                    <select
                                                        className="form-select"
                                                        value={filterTeacher}
                                                        onChange={(e) => setFilterTeacher(e.target.value)}
                                                    >
                                                        <option value="">Select Teachers</option>
                                                        {staffs.map((staff) => (
                                                            <option key={staff.id} value={staff.id}>
                                                                {staff.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="col-md-auto">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-primary w-100"
                                                        onClick={resetFilters}
                                                    >
                                                        <i className="bi bi-arrow-clockwise me-1"></i>
                                                        Reset
                                                    </button>

                                                </div>

                                                <div className="col-md-auto">
                                                    {hasAccess("/timetable/print") && (
                                                        <button
                                                            className="btn btn-outline-danger"
                                                            onClick={() => printElementV2("PrintDiv", "", 0.6)}
                                                        >
                                                            <i className="ri-printer-line"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card border-0 shadow-sm mb-4" id="PrintDiv">
                                        <div className="card-header d-flex justify-content-between align-items-center">
                                            <div>
                                                <h6 className="mb-0 fw-semibold text-primary">
                                                    <i className="bi bi-calendar-week me-2"></i>
                                                    Weekly Time Table
                                                </h6>
                                            </div>

                                            <span className="badge bg-primary">{data.length} Entries</span>
                                        </div>

                                        <div className="card-body p-0">
                                            {loading ? (
                                                <div className="text-center py-5">
                                                    <div className="spinner-border text-primary" role="status" />
                                                    <div className="mt-2 text-muted">Loading timetable...</div>
                                                </div>
                                            ) : (
                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-hover align-middle mb-0 border-primary">
                                                        <thead className="table-primary border-primary">
                                                            <tr>
                                                                <th className="text-center" style={{ minWidth: "180px" }}>
                                                                    Schedule
                                                                </th>

                                                                {days.map((day) => (
                                                                    <th key={day} className="text-center" style={{ minWidth: "220px" }}>
                                                                        <div className="fw-bold text-primary">{day}</div>
                                                                    </th>
                                                                ))}
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {schedules.length === 0 ? (
                                                                <tr>
                                                                    <td colSpan={days.length + 1} className="text-center py-4 text-muted">
                                                                        No schedules found.
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                schedules.map((schedule) => (
                                                                    <tr key={schedule.id}>
                                                                        <th className="text-center bg-light text-primary">
                                                                            <div className="fw-bold">{schedule.title}</div>
                                                                            <small className="text-muted">
                                                                                {formatTime(schedule.start_time)} - {formatTime(schedule.end_time)}
                                                                            </small>
                                                                        </th>

                                                                        {days.map((day) => {
                                                                            const group = findGroup(schedule.id, day);

                                                                            return (
                                                                                <td key={day} className="text-center">
                                                                                    {group.length > 0 ? (
                                                                                        group.map((item, index) => (
                                                                                            <div
                                                                                                key={item.id}
                                                                                                className={index > 0 ? "border-top pt-2 mt-2" : ""}
                                                                                            >
                                                                                                <div className="badge bg-label-primary mb-1">
                                                                                                    {item?.batch?.title || `Batch ${item.batch_id}`}
                                                                                                </div>

                                                                                                <div className="fw-bold text-dark">
                                                                                                    {item?.subject?.name ||
                                                                                                        item?.subject?.subject_name ||
                                                                                                        `Subject ${item.subject_id}`}
                                                                                                </div>

                                                                                                <div className="text-primary small">
                                                                                                    <i className="bi bi-person me-1" />
                                                                                                    {item?.teacher?.name || `Teacher ${item.teacher_id}`}
                                                                                                </div>
                                                                                            </div>
                                                                                        ))
                                                                                    ) : (
                                                                                        <span className="text-muted">—</span>
                                                                                    )}
                                                                                </td>
                                                                            );
                                                                        })}
                                                                    </tr>
                                                                ))
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}